import { createSelector } from 'reselect';

const selectCategories = (state: any) => state.categories;


export const selectCategoriesCurrentItem = createSelector([selectCategories], (categories) => categories.current);

export const selectCategoriesListItems = createSelector([selectCategories], (categories) => categories.list);

export const selectCategoriesItemById = (itemId: any) =>
    createSelector(selectCategoriesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCategoriesQueryItems = createSelector([selectCategories], (categories) => categories.query);

export const selectCategoriesCreatedItem = createSelector([selectCategories], (categories) => categories.create);

export const selectCategoriesUpdatedItem = createSelector([selectCategories], (categories) => categories.update);

export const selectCategoriesReadItem = createSelector([selectCategories], (categories) => categories.read);

export const selectCategoriesDeletedItem = createSelector([selectCategories], (categories) => categories.delete);

export const selectCategoriesearchedItems = createSelector([selectCategories], (categories) => categories.search);

export const selectCategoriesItemsCount = createSelector([selectCategories], (categories) => categories.count);

export const selectCategoriesItemsFilter = createSelector([selectCategories], (categories) => categories.filter);